import { useLocation } from 'react-router-dom';
import { Alert } from '@/components/Alert';

/**
 * Aviso deixado por uma tela que já foi embora (ex.: o primeiro acesso, que leva direto para
 * a tela inicial), passado no `state` da navegação: `navigate('/', { state: { aviso } })`.
 */
export function AvisoDaNavegacao() {
  const aviso = (useLocation().state as { aviso?: unknown } | null)?.aviso;
  if (typeof aviso !== 'string') return null;
  return (
    <Alert tone="success" role="status" className="mb-6">
      {aviso}
    </Alert>
  );
}
